import React from 'react';
import { BackgroundInspector } from './background-inspector';
import { FillInspector } from './fill-inspector';
import { GlowInspector } from './glow-inspector';
import { ShadowInspector } from './shadow-inspector';
import { StrokeInspector } from './stroke-inspector';
import './style.less';

type Props = {};

const TextEffectController = () => {
    return (
        <div className="text-effect-fast-operate">
            <FillInspector />
            <StrokeInspector />
            <ShadowInspector />
            <GlowInspector />
            <BackgroundInspector />
        </div>
    );
};

export default React.memo(TextEffectController);
